import { render, staticRenderFns } from "./template-4.vue?vue&type=template&id=e38f746a&scoped=true"
import script from "./template-4.vue?vue&type=script&lang=js"
export * from "./template-4.vue?vue&type=script&lang=js"
import style0 from "./template-4.vue?vue&type=style&index=0&id=e38f746a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38f746a",
  null
  
)

export default component.exports